export const analyticArgumentsQuery = `
  $projectId: Id!,
  $start: Timestamp!,
  $end: Timestamp!,
  $objectList: [Id!]!,
  $labelList: [Id!],
  $excludeLabelList: [Id!],
  $granularity: GranularityInput!,
  $timezone: Int!,
  $sentiment: [Sentiment!],
  $postOwnership: [PostOwnership!],
  $validationList: [StreamValidation!],
  $includeKeywords: [String!],
  $excludeKeywords: [String!],
  $fromUsername: String!,
  $contentTypeList: [ContentType!],
  $sentimentConfidenceLevelMin:BigDecimal!,
  $sentimentConfidenceLevelMax:BigDecimal!,
  $replyToOriginalId: [String!],
  $showEmptyLabel: Boolean,
  $queryStringBooleanOperator: QueryStringBooleanOperator,
  $languageList: [String!],
  $userRating: [Int!],
  $validationEmotionList: [StreamValidation!],
  $emotion: [Emotion!],
  $retweetFilter: RetweetFilter,
  $talkType: [TalkType!],
  $ageGeneration: [AgeGeneration!],
  $searchScope: SearchScope
  `;

export const analyticArguments = `
  projectId: $projectId,
  start: $start,
  end: $end,
  objectList: $objectList,
  labelList: $labelList,
  excludeLabelList: $excludeLabelList,
  granularity: $granularity,
  timezone: $timezone,
  sentiment: $sentiment,
  postOwnership: $postOwnership,
  validationList: $validationList,
  includeKeywords: $includeKeywords,
  excludeKeywords: $excludeKeywords,
  fromUsername: $fromUsername,
  contentTypeList: $contentTypeList,
  sentimentConfidenceLevelMin:$sentimentConfidenceLevelMin,
  sentimentConfidenceLevelMax:$sentimentConfidenceLevelMax,
  replyToOriginalId:$replyToOriginalId,
  showEmptyLabel: $showEmptyLabel,
  queryStringBooleanOperator: $queryStringBooleanOperator,
  languageList: $languageList,
  userRating: $userRating,
  emotion: $emotion,
  validationEmotionList: $validationEmotionList,
  retweetFilter: $retweetFilter,
  talkType: $talkType,
  ageGeneration: $ageGeneration,
  searchScope: $searchScope
  `;

export const analyticArgumentsQueryOnlineMedia = `
  $projectId: Id!,
  $start: Timestamp!,
  $end: Timestamp!,
  $mediaList: [String!]!,
  $granularity: GranularityInput!,
  $excludeMediaList:[String!],
  $timezone: Int!,
  $phrases: [String!],
  $sentiment: [Sentiment!],
  $labelList: [Id!],
  $clippingId: Id,
  $includeKeywords: [String!],
  $excludeKeywords: [String!],
  $searchType: SearchType,
  $languageList:[String!],
  $validationList: [ValidationType!],
  $queryStringBooleanOperator: QueryStringBooleanOperator,
  $tier: [Int!],
  $excludeLabelList: [Id!],
  $showEmptyLabel: Boolean,
  $countryCode: [String!],
  $peoples: [String!]
  `;

export const analyticArgumentsOnlineMedia = `
  projectId: $projectId,
  start: $start,
  end: $end,
  mediaList: $mediaList,
  granularity: $granularity,
  excludeMediaList: $excludeMediaList,
  timezone: $timezone,
  phrases: $phrases,
  sentiment: $sentiment,
  labelList: $labelList,
  clippingId: $clippingId,
  includeKeywords: $includeKeywords,
  excludeKeywords: $excludeKeywords,
  searchType: $searchType,
  languageList: $languageList,
  validationList: $validationList,
  queryStringBooleanOperator: $queryStringBooleanOperator,
  tier: $tier,
  excludeLabelList: $excludeLabelList,
  showEmptyLabel: $showEmptyLabel,
  countryCode: $countryCode,
  peoples: $peoples,
  `;

export const analyticArgumentsQueryOfflineMedia = `
  $projectId: Id!,
  $start: Timestamp!,
  $end: Timestamp!,
  $mediaList: [String!]!,
  $granularity: GranularityInput!,
  $timezone: Int!,
  $sentiment: [Sentiment!],
  $labelList: [Id!],
  $clippingId: Id,
  $includeKeywords: [String!],
  $excludeKeywords: [String!],
  $phrases: [String!],
  $languageList:[String!],
  $searchType: SearchType,
  $validationList: [ValidationType!],
  $tier: [Int!],
  $offlineMediaType: OfflineMediaType,
  $includeClipping: Boolean
  `;

export const analyticArgumentsOfflineMedia = `
  projectId: $projectId,
  start: $start,
  end: $end,
  mediaList: $mediaList,
  granularity: $granularity,
  timezone: $timezone,
  sentiment: $sentiment,
  labelList: $labelList,
  clippingId: $clippingId,
  includeKeywords: $includeKeywords,
  excludeKeywords: $excludeKeywords,
  phrases: $phrases,
  languageList: $languageList,
  searchType: $searchType,
  validationList: $validationList,
  tier: $tier,
  offlineMediaType: $offlineMediaType,
  includeClipping: $includeClipping
  `;
